<template lang="pug">
aside-modal(
    :id="id"
    width="w-xtra-large"
    :loading="onLoading('fetch-transaction')"
)
    span(slot="header-text") {{ receiptType === 'VOID' && !loading ? 'Voided' : '' }} Receipts

    div.padding.receipt(slot="body")
        div(v-if="!loading")
            receipt-details
            receipt-orders
            receipt-amount
            receipt-footer
            receipt-eft-details
            receipt-loyalty-details
        div(v-else)
            h1.text-center
                v-loading(loader="fetch-transaction")

    button(
        slot="footer"
        :disabled="loading"
        @click="print()"
        class="btn btn-fw dark"
    ) Print
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import receiptDetails from './details.vue';
import receiptOrders from './orders.vue';
import receiptAmount from './amount.vue';
import receiptFooter from './footer.vue';
import receiptLoyaltyDetails from './loyalty-details.vue';
import receiptReturnOrders from './return-orders';
import receiptReturnAmount from './return-amount';
import StoreMixin from './store-mixin';
import fileDownload from 'js-file-download';
import receiptEftDetails from './receipt-eft-details.vue';

export default {
    components: {
        receiptEftDetails,
        receiptDetails,
        receiptOrders,
        receiptAmount,
        receiptFooter,
        receiptLoyaltyDetails,
        receiptReturnOrders,
        receiptReturnAmount,
    },

    mixins: [StoreMixin],

    props: {
        id: {
            type: String,
            default: 'receipt-pgsql',
        },
    },

    computed: {
        ...mapGetters('transactionPostgres', [
            'pgsql_transaction',
            'receiptType',
        ]),

        loading() {
            return this.onLoading('fetch-transaction');
        },
    },

    created() {
        this.registerEvent();
    },

    methods: {
        ...mapActions('transactionPostgres', ['getTransactionPostgres']),

        print() {
            let url = Laroute.route(
                'franchise.report.transaction.exportReceiptPostgres',
            );

            this.$http({
                url: url,
                responseType: 'blob',
                method: 'post',
                headers: { Accept: 'multipart/form-data' },
                data: this.pgsql_transaction,
            }).then(response => {
                fileDownload(response.data, 'Receipt.pdf');
            });
        },

        registerEvent() {
            this.$on('show-receipt-postgres', receiptNumber => {
                if (this.loading) return;

                this.toggleModal('show');
            });
        },

        toggleModal(action) {
            $('#receipt-pgsql').modal(action);
        },
    },
};
</script>
